import {useState} from "react";
import AjaxService from "../../platform/ajax/AjaxService";

interface UploadTechDrawProps {
    onUploadSuccess?: () => void;
}

export const UploadTechDraw = ({ onUploadSuccess }: UploadTechDrawProps) => {
    const [file, setFile] = useState<File | null>(null);
    const [isUploading, setIsUploading] = useState(false);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            setFile(e.target.files[0]);
        }
    };

    const handleUpload = async () => {
        if (file) {
            setIsUploading(true);
            console.log('Uploading file...');

            const formData = new FormData();
            formData.append('file', file);

            try {
                const data = await AjaxService.postFormData('/api/tech-draws/upload', formData);
                console.log(data);
                
                // Reset file input after successful upload
                setFile(null);
                
                // Call the onUploadSuccess callback to refresh the page
                if (onUploadSuccess) {
                    onUploadSuccess();
                }
                
            } catch (error) {
                console.error(error);
                alert("Nie udało się załadować pliku");
            } finally {
                setIsUploading(false);
            }
        }
    };

    return (
        <>
            <div className="input-group">
                <input 
                    id="file" 
                    type="file" 
                    onChange={handleFileChange}
                    disabled={isUploading}
                />
            </div>
            {file && (
                <section>
                    File details:
                    <ul>
                        <li>Nazwa: {file.name}</li>
                        <li>Typ: {file.type}</li>
                        <li>Rozmiar: {file.size/1024} kB</li>
                    </ul>
                </section>
            )}

            {file && (
                <button
                    onClick={handleUpload}
                    className="btn btn-primary"
                    disabled={isUploading}
                >
                    {isUploading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                            Ładowanie...
                        </>
                    ) : (
                        'Wgraj plik'
                    )}
                </button>
            )}
        </>
    );
};
